var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdffile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.4,
    width: 19.2,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3822"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13598",
    className: "cls-2",
    d: "M6.47,14.43h-1.03s-.05.02-.05.04c0,0,0,0,0,.01v1.57s.02.05.05.05c0,0,0,0,0,0h1.03c.46.04.87-.3.91-.77.04-.46-.3-.87-.77-.91-.05,0-.1,0-.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13599",
    className: "cls-2",
    d: "M11.8,14.46h-.62s-.05.01-.06.04c0,0,0,0,0,.01v3.72s.01.05.04.05c0,0,0,0,.01,0h.62c.62,0,1.07-.21,1.23-.71.09-.4.13-.8.11-1.21.02-.41-.02-.81-.11-1.21-.16-.49-.61-.71-1.23-.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13600",
    className: "cls-2",
    d: "M21,9.6h-3c-3.31,0-6-2.69-6-6h0V.6C12,.27,11.73,0,11.4,0c0,0,0,0,0,0h-4.2C4.55,0,2.4,2.15,2.4,4.8h0v14.4c0,2.65,2.15,4.8,4.8,4.8h9.6c2.65,0,4.8-2.15,4.8-4.8h0v-9c0-.33-.27-.6-.6-.6,0,0,0,0,0,0M6.56,17.27h-1.11s-.05.02-.06.04c0,0,0,0,0,.01v1.51c.03.36-.25.68-.61.71-.02,0-.04,0-.06,0-.37,0-.67-.28-.68-.65,0-.02,0-.04,0-.06v-4.98c-.03-.3.2-.57.5-.59.03,0,.06,0,.08,0h1.93c1.11-.09,2.08.73,2.17,1.83.09,1.11-.73,2.08-1.83,2.17-.11,0-.23,0-.34,0M14.33,18.06c-.33,1.02-1.16,1.44-2.48,1.44h-1.48c-.3.02-.56-.2-.59-.5,0-.03,0-.06,0-.09v-5.06c-.02-.3.2-.57.5-.59.03,0,.05,0,.08,0h1.48c1.33,0,2.15.42,2.48,1.44.15.55.22,1.11.18,1.68.03.57-.03,1.13-.18,1.68M19.33,14.43h-2.21s-.05.01-.05.04c0,0,0,.01,0,.02v1.31s.01.05.04.05c0,0,.01,0,.02,0h1.76c.32-.03.6.21.63.53.03.32-.21.6-.53.63-.03,0-.06,0-.1,0h-1.76s-.05.01-.05.04c0,0,0,.01,0,.02v1.78c.03.37-.26.69-.63.72s-.69-.26-.72-.63c0-.03,0-.06,0-.09v-4.98c-.02-.3.2-.57.5-.59.03,0,.05,0,.08,0h3.03c.32-.02.6.23.62.55.02.32-.23.6-.55.62-.02,0-.05,0-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13601",
    className: "cls-2",
    d: "M18,7.2h2.66c.28.02.52-.19.55-.47,0-.09-.01-.19-.05-.27-.16-.3-.37-.57-.61-.81L15.95,1.06c-.24-.24-.51-.45-.81-.61-.25-.13-.56-.03-.68.22,0,0,0,0,0,0-.04.08-.06.18-.05.27v2.66c0,1.99,1.61,3.6,3.6,3.6h0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdffile);
export default __webpack_public_path__ + "static/media/icon_pdffile.cf54e69a991f389e352a4cb021437634.svg";
export { ForwardRef as ReactComponent };